import React from "react";
import { Flex, GridItem, Text } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { Checkbox } from "components";
import { FormValues } from "../../duck";
import { ORTHODONTICS_OPTIONS } from "./duck";

const Orthodontics: React.FC = () => {
  const { watch, setValue } = useFormContext<FormValues>();
  const orthodonticsValues = watch("orthodontics");

  return (
    <GridItem>
      <Flex direction="column" rowGap="4">
        <Text fontWeight="semibold" color="gray.600">
          Orthodontics
        </Text>

        {ORTHODONTICS_OPTIONS.map(opt => (
          <Checkbox
            key={opt.value}
            label={opt.label}
            isChecked={orthodonticsValues.includes(opt.value)}
            onChange={event => {
              const { checked } = event.target;
              if (checked) {
                setValue("orthodontics", [...orthodonticsValues, opt.value]);
              } else {
                setValue(
                  "orthodontics",
                  orthodonticsValues.filter(value => value !== opt.value)
                );
              }
            }}
          />
        ))}
      </Flex>
    </GridItem>
  );
};

export default Orthodontics;
